import { BaseDao } from './BaseDao';
import { Injectable } from '@angular/core';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';

@Injectable()
export class StationDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.STATION, apiHelper);
  }
}
